import { useState } from "react"

import useUser from "@hooks/useUser"

import { faIcon } from "@utils/faIcon"

import { Button, Icon, Tooltip } from "@atoms"

import { UserAvatar } from "@molecules"

import AvatarEditMenu from "@pages/Settings/SettingsProfile/components/AvatarManagement/AvatarEditMenu/AvatarEditMenu"
import { useAvatarManagement } from "@pages/Settings/SettingsProfile/components/AvatarManagement/AvatarManagement.store"

import styles from "./AvatarCard.module.scss"

export default function AvatarCard() {
    const { user } = useUser()
    const { selectImageFromOS, handleDeleteAvatar } = useAvatarManagement()
    const [isMenuOpen, setIsMenuOpen] = useState(false)

    return (
        <div className={styles.base}>
            <div className={styles.container}>
                {user?.avatar ? (
                    <>
                        <Tooltip body="Remove" defaultPlacement="bottom">
                            <div className={styles.avatarWrapper}>
                                <UserAvatar user={user} size="huge" />
                                <div
                                    className={`${styles.hoverOverlay} light-theme`}
                                    onClick={(e) => {
                                        e.stopPropagation()
                                        handleDeleteAvatar()
                                    }}
                                >
                                    <Icon
                                        icon={faIcon({ name: "trash-can", style: "regular" })}
                                        size={20}
                                        className={styles.hoverIcon}
                                    />
                                </div>
                            </div>
                        </Tooltip>

                        <AvatarEditMenu
                            isOpen={isMenuOpen}
                            onOpenChange={setIsMenuOpen}
                            onUpload={selectImageFromOS}
                            onRemove={handleDeleteAvatar}
                        >
                            <Button
                                variant="subtle"
                                size="md"
                                onClick={() => setIsMenuOpen(true)}
                                leftIcon={faIcon({ name: "pen", style: "regular" })}
                                isPressed={isMenuOpen}
                            >
                                Edit
                            </Button>
                        </AvatarEditMenu>
                    </>
                ) : (
                    <div className={styles.container}>
                        <Tooltip body="Upload" defaultPlacement="bottom">
                            <div
                                className={styles.avatarWrapper}
                                onClick={(e) => {
                                    e.stopPropagation()
                                    selectImageFromOS()
                                }}
                            >
                                {user && <UserAvatar user={user} size="huge" />}
                                <div className={`${styles.hoverOverlay} light-theme`}>
                                    <Icon
                                        icon={faIcon({ name: "upload", style: "regular" })}
                                        size={20}
                                        className={styles.hoverIcon}
                                    />
                                </div>
                            </div>
                        </Tooltip>

                        <Button
                            variant="subtle"
                            size="lg"
                            onClick={selectImageFromOS}
                            leftIcon={faIcon({ name: "upload", style: "regular" })}
                        >
                            Upload
                        </Button>

                        <span className={styles.uploadText}>Under 512Kb in JPG, PNG, or WEBP</span>
                    </div>
                )}
            </div>
        </div>
    )
}
